import * as SliderPrimitive from '@radix-ui/react-slider';
import * as React from 'react';

import {
  INTERACTIVE_STATES,
  SIZE_SCALE,
  COLOR_SCALE,
  SHADOW_SCALE,
} from '@/components/design-system/tokens';
import { cn } from '@/lib/utils';

type SliderProps = React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>;

const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, SliderProps>(
  ({ className, ...props }, ref) => (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        `relative flex ${SIZE_SCALE.full} touch-none select-none items-center`,
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className={`relative ${SIZE_SCALE['1.5']} ${SIZE_SCALE.full} grow overflow-hidden rounded-full ${COLOR_SCALE['primary-bg']}/20`}
      >
        <SliderPrimitive.Range className={`absolute h-full ${COLOR_SCALE['primary-bg']}`} />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          `block ${SIZE_SCALE['4']} ${SIZE_SCALE.w4} rounded-full border ${COLOR_SCALE['primary-border']}/50 ${COLOR_SCALE.background} ${SHADOW_SCALE.md} transition-colors`,
          INTERACTIVE_STATES.focus.outline,
          INTERACTIVE_STATES.focus.ring,
          INTERACTIVE_STATES.disabled.pointer,
          INTERACTIVE_STATES.disabled.opacity
        )}
      />
    </SliderPrimitive.Root>
  )
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
